import { gql } from '@apollo/client';

export default gql`
  {
    passengerDetails @client {
      birthDate
      countryCode
      email
      firstName
      paxId
      lastName
      unformattedPhoneNumber {
        countryCode
        number
      }
      loyaltyNumber
      type
    }
  }
`;
